export enum HttpProgressState {
  start,
  end
}
